/* Potato & Co. feature-my-order checkbox
 * Adds an opt-in above the Checkout button on the cart page and in the cart drawer.
 * Saved as a cart attribute, so it appears under Additional details on the order.
 * Unticked removes the attribute. Film only orders that show it.
 */
(function () {
  'use strict';
  if (window.potatoFeatureOrderLoaded) return;
  window.potatoFeatureOrderLoaded = true;

  var KEY = 'Feature on socials';
  var TEXT = 'Can we feature your order on our socials? Don\'t tick this if it includes a gift. \uD83C\uDF81';
  var isChecked = false;
  var queue = Promise.resolve();
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var style = document.createElement('style');
  style.textContent =
    '.potato-feature{display:block;margin-block-end:12px}' +
    '.potato-feature label{display:flex;align-items:flex-start;gap:10px;cursor:pointer;line-height:1.4;text-align:start}' +
    '.potato-feature input{-webkit-appearance:auto!important;appearance:auto!important;position:static!important;opacity:1!important;flex:0 0 auto;width:18px;height:18px;margin:1px 0 0;accent-color:#362624}';
  document.head.appendChild(style);

  function save() {
    var attributes = {};
    attributes[KEY] = isChecked ? 'Yes' : '';
    queue = queue.then(function () {
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes: attributes })
      });
    }).catch(function () {});
  }

  function syncInputs() {
    Array.prototype.forEach.call(document.querySelectorAll('.potato-feature input'), function (input) {
      input.checked = isChecked;
    });
  }

  function build(formId) {
    var wrap = document.createElement('div');
    wrap.className = 'potato-feature';
    var label = document.createElement('label');
    var input = document.createElement('input');
    input.type = 'checkbox';
    input.name = 'attributes[' + KEY + ']';
    input.value = 'Yes';
    input.checked = isChecked;
    input.setAttribute('form', formId);
    var span = document.createElement('span');
    span.textContent = TEXT;
    label.appendChild(input);
    label.appendChild(span);
    wrap.appendChild(label);
    /* Keeps the theme's quantity handler from reacting to this box */
    wrap.addEventListener('change', function (event) {
      event.stopPropagation();
      isChecked = input.checked;
      syncInputs();
      save();
    });
    return wrap;
  }

  function mountBefore(target, formId) {
    if (!target || !target.parentNode) return;
    var previous = target.previousElementSibling;
    if (previous && previous.classList.contains('potato-feature')) return;
    target.parentNode.insertBefore(build(formId), target);
  }

  function mount() {
    mountBefore(document.querySelector('.cart__checkout'), 'cartForm');
    var drawerButton = document.querySelector('.js-cart-drawer-submit-btn');
    mountBefore(drawerButton && drawerButton.parentNode, 'cart-drawer-form');
  }

  function init() {
    mount();
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        mount();
      });
    }).observe(document.body, { childList: true, subtree: true });

    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        isChecked = !!(cart.attributes && cart.attributes[KEY]);
        syncInputs();
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
